const LAST_ACTIVITY_KEY = 'lastActivity';
const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;

export const activityTracker = {
  updateLastActivity() {
    const now = Date.now();
    localStorage.setItem(LAST_ACTIVITY_KEY, now.toString());
  },

  getLastActivity() {
    const stored = localStorage.getItem(LAST_ACTIVITY_KEY);
    return stored ? parseInt(stored, 10) : null;
  },

  hasBeenInactiveForTwoWeeks() {
    const lastActivity = this.getLastActivity();
    if (!lastActivity) {
      return true; // First time user
    }
    
    const now = Date.now();
    const timeSinceLastActivity = now - lastActivity;
    return timeSinceLastActivity >= TWO_WEEKS_MS;
  },

  shouldShowLandingPage() {
    const params = new URLSearchParams(window.location.search);
    const showLandingParam = params.get('showlanding');
    
    // Force show if URL parameter is present
    if (showLandingParam === 'true' || showLandingParam === '1') {
      return true;
    }

    // Show for first-time users, or when returning after two weeks.
    if (this.hasBeenInactiveForTwoWeeks()) {
      return true;
    }

    return false;
  },

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
};
